import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectKeyLabel: {
		id: 'project-details.label-for-project-key-field',
		defaultMessage: 'Project key',
		description: 'Label for the Project key field',
	},
	infoTriggerLabel: {
		id: 'project-details.previous-project-keys-info-trigger-label',
		defaultMessage: 'More about project keys',
		description: 'Label for the info trigger for the released historical project keys field',
	},
});
